module.exports = __webpack_public_path__ + "9b8e60266ff496b521261e32f61165b6.png";